<script setup>
import { JList } from "media-flow-ui";

import { ref, computed } from "vue";
import { storeToRefs } from "pinia";

import { formatComponentStyle } from "@/models/layout/style/component";

const props = defineProps({
  data: {
    type: Object,
    required: false,
    default: false,
  },
});

const { data } = props

const style = computed(() => formatComponentStyle(data?.style || {}))
const buttonStyle = computed(() => formatComponentStyle(data?.components?.button?.style || {}))
</script>
<template>
  <div>
    <j-list
      :orientation="data.props.orientation"
      :has-limit="data.props.hasLimit"
      :limit="data.props.limit"
      :number-of-items="data.props.numberOfItems"
      :style="style"
      :button-style="buttonStyle"
      class="j-list"
    >
      <template #item="{ index }">
        <Identifier
          :component="data.item"
          :data="data.item"
          :key="data.item.id"
          :index="index"
          is-list
        />
      </template>
    </j-list>
  </div>
</template>